import { Heading, InlineNotification } from '@msaf/core-react'

export interface PublicDocumentLink {
  documentType: string | null
  documentReference: string
  documentLinkUrl: string
}

interface PublicDocumentLinksProps {
  links: PublicDocumentLink[]
  editNotice?: string
}

export default function PublicDocumentLinks({ links, editNotice }: PublicDocumentLinksProps) {
  if (!links.length) return null

  return (
    <div className='c-public-document-links'>
      <Heading level={3} className='c-file-list__heading'>
        Linked documents
      </Heading>
      {editNotice && (
        <InlineNotification messageType='info' isDismissable={false}>
          {editNotice}
        </InlineNotification>
      )}
      <ul>
        {links.map((link, index) => {
          let label = [link.documentType, link.documentReference].filter((val) => !!val).join(' - ')
          if (!label) {
            label = link.documentLinkUrl
          }
          return (
            <li key={index}>
              <a href={link.documentLinkUrl} target='_blank' rel='noopener noreferrer'>
                {label}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
